/*
|--------------------------------------------------------------------------
| Stubs root
|--------------------------------------------------------------------------
|
| Path to the root directory where stubs are located. This will be used
| during the configure hook to copy the stubs to the user's application.
|
*/

import { getDirname } from '@adonisjs/core/helpers'

export const stubsRoot = getDirname(import.meta.url)
